import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from './Modal';
import i18n from '../utils/i18n';
import { resetModal } from '../actions/modalsActions';
import { formatDateForSessionCard } from '../utils/other';

import './styles/BookingCompleteModal.scss';

const BookingCourtCompleteModal = ({ resetModal: reset, modalData }) => (
  <div className="booking-complete-modal">
    <Modal
      isOpen={ true }
      onRequestClose={ reset }
      closeButtonText={ i18n.t('modals.bookingComplete.DONE') }
      showActionButton={ false }
    >
      <div className="modal-container booking-complete-modal-container">
        <h1 className="modal-header booking-complete-modal-header">
          {i18n.t('modals.bookingComplete.BOOKING_CONFIRMED')}
        </h1>
        <p>
          {i18n.t('modals.bookingComplete.BOOKED_TYPE_OF_COURT', {
            courtType: modalData.courtType
          })}
        </p>
        <p>
          {formatDateForSessionCard(modalData.startTime, modalData.eventDate)}
        </p>
        <p>
          {modalData.eventClubName}
          {' '}
          <br />
          {modalData.eventLocation}
        </p>
      </div>
    </Modal>
  </div>
);

BookingCourtCompleteModal.propTypes = {
  resetModal: PropTypes.func.isRequired,
  modalData: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  modalData: state.modals.modalData
});

export default connect(
  mapStateToProps,
  { resetModal }
)(BookingCourtCompleteModal);



// WEBPACK FOOTER //
// ./src/modals/BookingCourtCompleteModal.js